//possibilites:
//  sessionStorage  --> data lasts until tab is closed
//  localStorage    --> data lasts until explicitly deleted
const storage = localStorage;

var SessionStorage = (function () {
  var persist = function (key, object) {
    const json = JSON.stringify(object);
    storage.setItem(key, json);
  };

  var retreive = function (key) {
    const json = storage.getItem(key);
    const object = JSON.parse(json);
    return object;
  };

  var remove = function (key) {
    storage.removeItem(key);
  };

  var exists = function (key) {
    return storage.getItem(key) !== null;
  };

  return {
    persist: persist,
    retreive: retreive,
    remove: remove,
    exists: exists
  };
})();

export default SessionStorage;
